export default "__VITE_ASSET__DRZtWrUO__"